import { Grid2,Typography,Box } from "@mui/material"
import Styles from "./Web.module.css"
import bg from "../../../../ui-utils/latestPics/research.mp4"
export default function Web() {
    return (
        <>
         <Grid2 className={Styles.outercard}>
                <Grid2 className={Styles.leftVideoSection}>
                    <video
                        className={Styles.video}
                        autoPlay
                        loop
                        muted
                        playsInline
                        controls={false}
                    >
                        <source src={bg} type="video/mp4" />
                    </video>
                </Grid2>
                <Grid2 className={Styles.rightContent}>
                    <Box>
                        <Typography  className={Styles.heading}>
                            Stock Market Research
                        </Typography>
                        <Typography className={Styles.text}>
                            Serious about knowing what happens to the money you invest in the stock market? Your curiosity has just 1 solution: you need to get serious about stock market research. With cumulative experience of 25+ years, our Research team prides itself on providing simplified research that you can rely on. With Triveni Management Consultancy Services Ltd, you can access as well as understand the thinking behind our Fundamental Research, Technical Research and Mutual Fund Research. This stock market research is not your typical market research, though, as our research is actionable, sharp, and backed by the expertise of our pedigreed Research Desk.
                        </Typography>
                    </Box>
                </Grid2>
         </Grid2>
        </>
    )
}